import axios from 'axios'

export default axios.create({
    baseURL: 'https://api-testing.lensadvisors.com/api',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    }
})